import { LOCAL_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export const getExamSummary = async (examId = 0, attempt = 0, userId = 0) => {
	try {
		const response = await axiosRequestInterceptor.post(`/exam/getExamSummary`, {
			examId: examId,
			attempt: attempt,
			userId: userId || "1066",
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.data.examData.error };
	}
};

export const getSFTData = async (examId = 0, userId = 0) => {
	try {
		const response = await axiosRequestInterceptor.post(`/sft/getSFTData`, {
			testId: examId,
			userId: userId,
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const getUserAttempts = async (examId = 0, userId = 0) => {
	try {
		const response = await axiosRequestInterceptor.post(`/exam/getUserExamAttempts`, {
			userId: userId,
			examId: examId,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.error };
	}
};

export const startReattemptWrong = async (
	userId = 0,
	examId = 0,
	attempt,
	reattemptNumber,
	questions,
	examName
) => {
	try {
		const response = await axiosRequestInterceptor.post("exam/startReattemptWrong", {
			userId,
			examId,
			attempt,
			reattemptNumber,
			questions,
			examName,
		});
		return { success: true, data: response?.data?.reattemptId };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error?.response?.error };
	}
};

export const getExamReattempts = async (userId, examId, attempt) => {
	try {
		const response = await axiosRequestInterceptor.post("exam/getUserReattepmts", {
			userId,
			examId,
			attempt,
		});
		if (response.status === 204) return { success: true, data: [] };
		return { success: true, data: response?.data?.Reattempts };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error?.response?.error };
	}
};

export const getReattempSummary = async (userId, reattemptId) => {
	try {
		const response = await axiosRequestInterceptor.post("exam/getReattemptSummary", {
			userId,
			reattemptId,
		});
		return { success: true, data: response?.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error?.response?.error };
	}
};
